const VALUATION_COMPONENT_CONST = {
  SECTOR_VALUATIONS: "Sector Valuations",
  PROFITABILITY: "Profitability",
  LEVERAGE: "Leverage",
  TECHNICAL: "Technical",
  END_MARKET_EXPOSURE: "End Market Exposure",
  PRICE_PERFORMANCE: "Price Performance",
  STOCK_CORRELATION: "Stock Correlation",
  MCAP: "Mcap",
  REVENUE_COMPOSITION: "Revenue composition",
};
const VALUATION = "Valuation";
const WATERFALL = "Waterfall";
const NOTIFICATION_TIMEOUT_TIME = 2000;
const APPROVED_USER = "approved";
const PENDING_USER = "pending";
const REJECTED_USER = "rejected";
const APPROVED_ACCESS_USER = "approve_access";

console.log("domain", process.env.VUE_APP_DOMAIN_URL);

export default {
  VALUATION: VALUATION,
  VALUATION_COMPONENT_CONST: VALUATION_COMPONENT_CONST,
  NOTIFICATION_TIMEOUT_TIME: NOTIFICATION_TIMEOUT_TIME,
  WATERFALL: WATERFALL,
  APPROVED_USER: APPROVED_USER,
  PENDING_USER: PENDING_USER,
  REJECTED_USER: REJECTED_USER,
  APPROVED_ACCESS_USER: APPROVED_ACCESS_USER,
};
